<template>
  <div>
    <b-modal size="xl" hide-footer v-model="modalLetters" class="w-100" title="La Carta">
      <b-row>
        <b-col md="3">
          <b-form-group label="Categoria:">
            <b-form-select @change="SearchProducts" v-model="id_category_letter" :options="categories_letter"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="9">
          <b-form-group label="Buscar la carta:">
            <b-form-input autofocus type="search" ref="search_letter" v-model="search_letter" @keyup="SearchProducts"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <div class="table-responsive mt-3">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th width="5%"  class="text-center align-middle">#</th>
                  <th width="8%"  class="text-center align-middle">Código</th>
                  <th width="45%"  class="text-center align-middle">Nombre</th>
                  <th width="10%"  class="text-center align-middle">Categoria</th>
                  <th width="10%"  class="text-center align-middle">U. M.</th>
                  <th width="5%"  class="text-center align-middle">Stock</th>
                  <th width="10%"  class="text-center align-middle">Cantidad</th>
                  <th width="7%"  class="text-center align-middle">Acciones</th>
                </tr>
              </thead>
              <tbody v-for="(item, it) in products" :key="it">
                <tr>
                  <td class="text-center">{{ it + 1 }}</td>
                  <td class="text-center">{{ item.code }}</td>
                  <td class="text-left">{{ item.name }}</td>
                  <td class="text-left">{{ item.category_name }}</td>
                  <td class="text-center">{{ NameUnitMeasure(item.unit_measure) }}</td>
                  <td class="text-right">{{ item.stock }}</td>
                  <td class="text-center">
                    <input type="number" step="any" value="1.00" v-model="item.quantity" class="form-control text-right">
                  </td>
                  <td class="text-center">
                    <b-button type="button" @click="AddLetter(it)" variant="primary"><i class="fas fa-plus-square"></i></b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<style>


</style>


<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";
import CodeToName from "@/assets/js/CodeToName";
export default {
  name: "ModalsProduct",
  data() {
    return {
        modalLetters:false,
        module:'Delivery',
        role:0,
        categories_letter:[],
        id_category_letter:'all',
        search_letter:'',
        id_warehouse:1,
        products: [],
    };
  },
  created (){
    
  },
  mounted () {
    EventBus.$on('ModalLettersShow', (role) => {
      this.modalLetters = true;
      this.role = role;
      this.ListCategoriesLetter();
    });
    

  },
  methods: {
      ListCategoriesLetter,
      SearchProducts,
      AddLetter,
      NameUnitMeasure,
      ...mapActions('Delivery',['mLoadAddDeliveryDetail']),
  },
  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function ListCategoriesLetter() {
  let me = this;
  let url = this.url_base + "category-letter/list-active";
  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: this.role},
  })
  .then(function (response) {
    me.categories_letter = [{value:'all',text:'-- Todos --'}];
    if (response.data.status == 200) {
      for (let index = 0; index < response.data.result.length; index++) {
        const element = response.data.result[index];
        me.categories_letter.push({value:element.id_category_letter,text:element.name})
      }
    } 
  })
  .catch((error) => {
    Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    
  });
}


function NameUnitMeasure(code) {
    return CodeToName.NameUnitMeasure(code);
}

function AddLetter(index) {
    let quantity = this.products[index].quantity;
    let id_letter = this.products[index].id_letter;
    if (quantity.length == 0) {
      me.$notify({ group: 'alert', title: 'Sistema', text:'Ingrese una cantidad', type: 'error'})
      return false;
    }
    let me = this;
    let url = this.url_base + "letter/view/" + id_letter;
    axios({
      method: "GET",
      url: url,
      headers: { token: this.token, module: this.module, role: this.role},
    })
    .then(function (response) {
      if (response.data.status == 200) {
        let total_price = parseFloat(response.data.result.letter.sale_price) * parseFloat(quantity)
        let detail = {
          id_letter: response.data.result.letter.id_letter,
          code: response.data.result.letter.code,
          name: response.data.result.letter.name + (response.data.result.letter.presentation.length == 0 ? '': ' - '+ response.data.result.letter.presentation),
          unit_measure: response.data.result.letter.name_unit_measure,
          igv: response.data.result.letter.igv,
          existence_type: response.data.result.letter.existence_type,
          quantity: parseFloat(quantity).toFixed(2),
          unit_price: parseFloat(response.data.result.letter.sale_price).toFixed(2),
          total_price: parseFloat(total_price).toFixed(2),
          observation:[],
        }
        me.mLoadAddDeliveryDetail(detail);
        me.$notify({ group: 'alert', title: 'Sistema', text:'Se ha agregado el producto '+detail.name, type: 'success'})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      console.log(error);
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });

   
}

//Buscar productos
function SearchProducts() {
  let me = this;
  let search = this.search_letter == "" ? "all" : this.search_letter;
  let url = this.url_base + "letter/search-stock-delivery";
  let data = {
    search : search,
    type_stock : 1,
    id_category_letter : this.id_category_letter,
    stock:0,
    id_warehouse:this.id_warehouse,
  };
  axios({
    method: "POST",
    url: url,
    data:data,
    headers: { token: this.token, module: this.module, role: this.role},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.products = response.data.result;
      } else {
        me.products = [];
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      
    });
}
</script>
